<template>
    <div>
        <div style="margin-top: 15px">
            <div class="tcs" v-for="item in shopNames">
                <span style="height: 23px;line-height: 23px;">{{item.name}}</span>
                <div class="tcitems">
                    <div class="tcitem" v-for="it in item.memberItems">
                        <span style="width: 60%">{{it.itemName}}</span>
                        <span style="width: 20%">x{{it.total-it.uses}}</span>
                        <span class="xzbtn" @click="toSc(it)">选择</span>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{tcItem.itemName}}</span>
                    <span class="jg">¥{{tcItem.price}}</span>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" @click="setLEmp(emp,1)"
                                  @dblclick="setDEmp(emp,1)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(1)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(1)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" @click="setLEmp(emp,2)"
                                  @dblclick="setDEmp(emp,2)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(2)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(2)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" @click="setLEmp(emp,3)"
                                  @dblclick="setDEmp(emp,3)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(3)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(3)">点</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addTcData"> 确定</div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                shopNames: [],

                show: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',

                total:0,
                tcItem:{},

            };
        },
        props:{
            member:Object,
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.toScItems()
        },
        methods: {
            async toScItems() {
                if (!this.member.id) {
                    return;
                }
                let res = await this.$get("/sw/getSwShopItems", {memberId: this.member.id});
                this.shopNames = res.names
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            toSc(item) {
                this.empShow = true
                let itemSign = 0
                if (item.lyType == 4) {
                    //秒杀套餐
                    itemSign = 5
                }
                if (item.lyType == 10) {
                    //请客卡
                    itemSign = 10
                }
                this.tcItem = {
                    itemId: item.itemId,
                    categoryId: item.categoryId,
                    itemName: item.itemName,
                    price: 0,
                    actual: item.mdAch,
                    oglPrice: item.price,
                    itemSign: itemSign,
                    discount: 0,
                    add: 0,
                    noteId: item.id,
                    first: item.firstAch,
                    second: item.secondAch,
                    third: item.thirdAch,
                    firstCmn: item.firstCmn,
                    secondCmn: item.secondCmn,
                    thirdCmn: item.thirdCmn,
                    tjType: 0,
                    femp: {},
                    semp: {},
                    temp: {},
                }
                this.getFwEmps()
            },

            addTcData() {
                let fEmp = {}
                let sEmp = {}
                let tEmp = {}
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.status != 0) {
                            fEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.status != 0) {
                            sEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.status != 0) {
                            tEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                this.tcItem.femp = fEmp
                this.tcItem.semp = sEmp
                this.tcItem.temp = tEmp
                this.empShow = false
                this.guanbi()
            },

            guanbi(){
                this.$emit('guanbi',this.tcItem)
            },

            async setLEmp(item, type) {
                this.setUnchecked(type);
                item.status = 1
            },

            async setDEmp(item, type) {
                this.setUnchecked(type);
                item.status = 2
            },

            // 将选中的人状态更改为没选中
            setUnchecked(type) {
                if (type == 1) {
                    this.changeEmpFalse(this.fEmps);
                }
                if (type == 2) {
                    this.changeEmpFalse(this.sEmps);
                }
                if (type == 3) {
                    this.changeEmpFalse(this.tEmps)
                }
            },
            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    if (item.status != 0) {
                        item.status = 0
                    }
                })
            },
            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tcs {
        font-size: 13px;
        padding: 10px 18px;
    }

    .tcitems {
        margin-top: 5px;
        background-color: #F7F7F7;
        padding: 16px;
    }

    .tcitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        height: 25px;
    }
    .xzbtn {
        width: 30px;
        color: #2b94ff;
    }

    .fw-gw-emps {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        height: 268px;
        border-bottom: #eeeeee solid 1px;
    }

    .emp-gw {
        width: 100%;
        text-align: center;
        border-right: #eeeeee solid 1px;
    }

    .gw {
        display: block;
        height: 30px;
        line-height: 30px;
        border-bottom: #eeeeee solid 1px;
    }

    .fw-gw-emp {
        height: 230px;
        display: flex;
        flex-direction: column;
        padding: 0px 5px;
        overflow: auto;
    }

    .emp {
        height: 20px;
        line-height: 20px;
        text-align: left;
        margin: 5px 0px 0px 5px;
        display: flex;
        flex-direction: row;
    }

    .empname {
        width: 90%;
    }

    .empgl {
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        margin: 0 3px;
        border-radius: 25px;
        color: #ffffff;
        position: relative;
        background-color: #616EB0;
        right: 0px;
    }
    .tiaozheng {
        margin-top: 5px;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .xiadanjiage {
        font-size: 11px;
        margin-right: 8px;
    }
    .adddatabtn {
        width: 100%;
        height: 32px;
        font-size: 18px;
        background-color: #2b94ff;
        text-align: center;
        color: #ffffff;
        line-height: 32px;
    }

    .ki {
        width: 60%;
    }
</style>
